import { render, staticRenderFns } from "./GroupImageBadgeDropdown.vue?vue&type=template&id=342dd2ba"
import script from "./GroupImageBadgeDropdown.js?vue&type=script&lang=js&external"
export * from "./GroupImageBadgeDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports